<template>
    <section id="detendre" class="RelaxSection">
      <div class="RelaxSection__head">
        <h2 :class="isPhone ? 'merriweather-reg-18' : 'merriweather-reg-32'">Pour se détendre</h2>
        <p v-if="text" class="RelaxSection__lead raleway-reg-p15">{{ text }}</p>
      </div>
  
      <div class="RelaxSection__railWrap">
        <button
          class="RelaxSection__arrow is-left"
          :disabled="!canScrollLeft"
          aria-label="Précédent"
          @click="scrollBy(-1)"
        >
          ‹
        </button>
  
        <div class="RelaxSection__rail" ref="rail" @scroll.passive="onScroll">
          <figure
            v-for="(img, i) in normalizedImages"
            :key="i"
            class="RelaxSection__item"
          >
            <img :src="img.src" :alt="img.alt || `Visuel ${i+1}`" loading="lazy" />
            <figcaption v-if="img.caption" class="RelaxSection__caption">
              {{ img.caption }}
            </figcaption>
          </figure>
        </div>
  
        <button
          class="RelaxSection__arrow is-right"
          :disabled="!canScrollRight"
          aria-label="Suivant"
          @click="scrollBy(1)"
        >
          ›
        </button>
      </div>
    </section>
  </template>
  
  <script>
  export default {
    name: 'RelaxSection',
    props: {
      text: { type: String, default: '' },
      images: { type: Array, default: () => [] }
    },
    data () {
      return {
        canScrollLeft: false,
        canScrollRight: false,
        isPhone: window.innerWidth < 768
      }
    },
    computed: {
      normalizedImages () {
        return (this.images || []).map(i => {
          if (typeof i === 'string') return { src: i }
          return { src: i.src, alt: i.alt, caption: i.caption }
        })
      }
    },
    methods: {
      updateButtons () {
        const el = this.$refs.rail
        if (!el) return
        const maxScroll = el.scrollWidth - el.clientWidth - 1
        this.canScrollLeft = el.scrollLeft > 0
        this.canScrollRight = el.scrollLeft < maxScroll
      },
      onScroll () {
        this.updateButtons()
      },
      scrollBy (dir = 1) {
        const el = this.$refs.rail
        if (!el) return
        const step = Math.max(el.clientWidth * 0.9, 320)
        el.scrollBy({ left: dir * step, behavior: 'smooth' })
        window.setTimeout(this.updateButtons, 350)
      }
    },
    mounted () {
      this.updateButtons()
      this._ro = () => this.updateButtons()
      window.addEventListener('resize', this._ro)
    },
    beforeDestroy () {
      window.removeEventListener('resize', this._ro)
    }
  }
  </script>
  
  <style>
  .RelaxSection { padding: clamp(24px, 4vw, 40px) clamp(12px, 4vw, 24px); }
  .RelaxSection__head { max-width: 1100px; margin: 0 auto; text-align: center; }
  .RelaxSection h2 {
    margin: 0 0 clamp(10px, 1.8vw, 14px);
  }
  .RelaxSection__lead {
    margin: 0 auto clamp(14px, 3vw, 24px);
    max-width: 1050px;
    line-height: 1.8;
    color: #222;
  }
  
  .RelaxSection__railWrap {
    position: relative;
    max-width: 1200px;
    margin: 0 auto;
  }
  
  .RelaxSection__rail {
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: minmax(260px, 1fr);
    gap: clamp(10px, 1.6vw, 16px);
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    padding: 2px 0 8px;
    scrollbar-width: thin;
  }
  .RelaxSection__item {
    scroll-snap-align: start;
    margin: 0;
    display: grid;
    gap: 10px;
  }
  .RelaxSection__item img {
    width: 100%;
    height: clamp(220px, 28vw, 420px);
    object-fit: cover;
    border-radius: 12px;
  }
  .RelaxSection__caption {
    font-family: 'Raleway', sans-serif;
    font-weight: 700;
    letter-spacing: .2px;
    text-transform: none;
  }
  
  .RelaxSection__arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 42px;
    height: 42px;
    border-radius: 50%;
    border: 1px solid #d9dfdc;
    background: #fff;
    color: #2d5f49;
    display: grid;
    place-items: center;
    font-size: 28px;
    line-height: 1;
    cursor: pointer;
    box-shadow: 0 2px 10px rgba(0,0,0,.08);
  }
  .RelaxSection__arrow:disabled {
    opacity: .35;
    cursor: default;
  }
  .RelaxSection__arrow.is-left { left: -4px; }
  .RelaxSection__arrow.is-right { right: -4px; }
  
  @media (min-width: 960px) {
    .RelaxSection__rail { grid-auto-columns: minmax(300px, 1fr); }
  }
  
  @media (max-width: 520px) {
    .RelaxSection__rail { grid-auto-columns: 85vw; }
    .RelaxSection__arrow.is-left { left: 4px; }
    .RelaxSection__arrow.is-right { right: 4px; }
  }
  </style>  